
































































































































import { Component, Vue, Ref } from "vue-property-decorator";
import User from "@/services/User";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import ModalAuthPrompt from "@/components/modal/ModalAuthPrompt.vue";
import TandatanganUploadCard from "@/components/TandatanganUploadCard.vue";

@Component({
  components: {
    ModalAuthPrompt,
    TandatanganUploadCard
  },
  beforeRouteLeave(to, from, next) {
    setTimeout(() => {
      window.location.reload();
    }, 250);

    next();
  }
})
export default class UserProfilePage extends Vue {
  @Ref("form") readonly form!: HTMLFormElement;
  @Ref("formPin") readonly formPin!: HTMLFormElement;

  valid = true;
  oldPassword = "";
  newPassword = "";
  confirmPassword = "";
  saving = false;

  validPin = true;
  oldPin = "";
  newPin = "";
  savingPin = false;
  toggleOldPass = false;
  toggleNewPass = false;

  oldPasswordRules: Array<(value: string) => string | boolean> = [
    (v: string) => !!v || "Password lama harus diisi"
  ];

  newPasswordRules: Array<(value: string) => string | boolean> = [
    (v: string) => !!v || "Password baru harus diisi",
    (v: string) => (v && v.length >= 8) || "Password harus minimal 8 karakter",
    (v: string) => /[A-Z]/.test(v) || "Password harus mengandung huruf kapital",
    (v: string) => /[a-z]/.test(v) || "Password harus mengandung huruf",
    (v: string) => /[0-9]/.test(v) || "Password harus mengandung angka",
    (v: string) =>
      /[@$!%?#&]/.test(v) ||
      "Password harus mengandung karakter khusus (@$!%?#&)"
  ];

  oldPinRules: Array<(value: string) => string | boolean> = [
    (v: string) => !!v || "Pin lama harus diisi"
  ];

  newPinRules: Array<(value: string) => string | boolean> = [
    (v: string) => !!v || "Pin baru harus diisi",
    (v: string) => (v && v.length == 6) || "Pin harus 6 karakter",
    (v: string) => /^[0-9]+$/.test(v) || "Pin harus Angka"
  ];

  get confirmPasswordRules(): Array<(value: string) => string | boolean> {
    return [
      (v: string) => !!v || "Konfirmasi password harus diisi",
      (v: string) => v === this.newPassword || "Password tidak cocok"
    ];
  }

  mounted() {
    userModule.resetSession(true);
  }

  submit(): void {
    if ((this.form as any).validate()) {
      if (!this.saving) {
        this.saving = true;
        User.changePassword(this.oldPassword, this.newPassword)
          .then(resp => {
            appModule.NoticeDelay(resp.message);

            userModule.resetSession();

            this.reset();
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }

  reset(): void {
    (this.form as any).reset();
  }

  submitPin(): void {
    if ((this.formPin as any).validate()) {
      if (!this.savingPin) {
        this.savingPin = true;
        User.changePinTtd(this.oldPin, this.newPin)
          .then(resp => {
            appModule.NoticeDelay(resp.message);

            this.resetPin();
          })
          .finally(() => {
            this.savingPin = false;
          });
      }
    }
  }

  resetPin(): void {
    (this.formPin as any).reset();
  }

  isShowVerifPinDialog = false;
  submittingLupaPin = false;

  showVerifPinDialog(): void {
    this.isShowVerifPinDialog = true;
  }

  submitLupaPin({ password }: { password: string }): void {
    if (!this.submittingLupaPin) {
      this.submittingLupaPin = true;

      User.resetPinTtd({ email: userModule.profile?.email, password })
        .then(resp => {
          appModule.sendErrorAlert(resp.message);
          this.isShowVerifPinDialog = false;
        })
        .finally(() => {
          this.submittingLupaPin = false;
        });
    }
  }
}
